import React, { Component } from 'react';
import { Grid, Header, Icon, Label, Popup, Table } from 'semantic-ui-react';
import SearchTableData from "../../util/SearchTableData";

class CollisionCourses extends Component {
    render() {
        return (
            <div>{ this.props.data.length ? <Table celled selectable compact>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell colSpan={16}>
                            <div style={{ paddingLeft: '30px' }}>
                                <SearchTableData data={this.props.data} getResults={this.props.getResults} filterItem={['id', 'courseBasicName']} />
                            </div>
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell >R. br.</Table.HeaderCell>
                        <Table.HeaderCell colSpan="10">
                            Predmet
                        </Table.HeaderCell>
                        <Table.HeaderCell colSpan="5">
                            <Header as="h4">
                                <Header.Content>
                                    Napomena
                                    <Header.Subheader>Predmet / implementacija</Header.Subheader>
                                </Header.Content>
                            </Header>
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body> {this.props.dataToShow.map((el, index) =>
                    (<Table.Row key={el.id}>
                        <Table.Cell verticalAlign="middle" >
                            {index + 1}.
                        </Table.Cell>
                        <Popup
                            content={el.semesters[0].name._key === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                            hideOnScroll
                            position="left center"
                            trigger={<Table.Cell verticalAlign="middle" colSpan="10">
                                <Grid columns={1} centered className="stackable">
                                    <Grid.Row verticalAlign="middle">
                                        <Grid.Column width="10">
                                            <span >  { el.semesters[0].name._key === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.code ? el.courseBasic.name + ' | ' + el.code : el.courseBasic.name}</span>
                                        </Grid.Column>
                                        <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                            {/* <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span> */}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Table.Cell>}
                        />
                        <Table.Cell verticalAlign="middle" colSpan="5">
                            <span>
                                {el.courseBasic.comment && <Popup content="Predmet" hideOnScroll position="top center" trigger={<Label as="a" basic><Icon name="comment alternate outline" /> {el.courseBasic.comment}</Label>} />}
                                {el.comment && <Popup content="Implementacija" hideOnScroll position="top center" trigger={<Label as="a" basic><Icon name="comment alternate outline" /> {el.comment}</Label>} />}
                                {el.collisionApproved && <Label as="a" basic><Icon name="random" />Kolizija</Label>}
                            </span>
                        </Table.Cell>
                    </Table.Row>))}
                </Table.Body>
            </Table> : <div><br />Nema predmeta u ovom semestru.<br /></div>}
            </div>
        );
    }
}

export default CollisionCourses;



// WEBPACK FOOTER //
// ./src/views/StudentService/Collision/CollisionCourses.js